import { useEffect, useState } from "react";
import { loader } from "../../../assets";
import { useCreateAuthMutation } from "../service";
import { FMDPStorage } from "../../../shared/helper";
import { QIButton } from "../../../components";
import { useNavigate } from "react-router-dom";
import { FMDPWebSocket } from "../../Shared/WebSocket";

export const ClientLogin = ({ username, callbackUrl, token, clientName, appId, profile }) => {
  const navigate = useNavigate();
  const [login, { isSuccess: loginSuccess, data, error: loginError }] = useCreateAuthMutation({
    fixedCacheKey: "shared-sso-data",
  });

  !callbackUrl && sessionStorage.setItem("fmdp-access-token", token);

  const [queryParams, setQueryParams] = useState({});
  const [loginErrorMessage, setLoginErrorMessage] = useState("Authentication Failed!");

  useEffect(() => {
    if (callbackUrl) {
      setQueryParams({
        username: username,
        callback_url: callbackUrl,
        token: token,
        client_name: clientName,
      });
    }
  }, [callbackUrl]);

  useEffect(() => {
    if (!callbackUrl && token) {
      FMDPStorage.set("selected-app-id", appId);
      FMDPStorage.set("live-view", true);
      FMDPStorage.set("localization-profile", profile);
      navigate("/app-selection");
    }
  }, []);

  // Call login Api when received the queryparams
  useEffect(() => {
    if (queryParams?.username && queryParams?.callback_url) {
      FMDPStorage.clear();
      (async () => {
        try {
          await login(queryParams).unwrap(); // Unwrap to get direct result and trigger success state
        } catch (err) {
          console.error("Login failed:", err);
        }
      })();
    }
  }, [queryParams]);

  // For successful login, set the selected app id
  useEffect(() => {
    if (loginSuccess) {
      if (queryParams?.username && queryParams?.callback_url) {
        FMDPStorage.set("selected-app-id", data?.selected_app_id);
      } else {
        FMDPStorage.set("selected-app-id", appId);
      }

      FMDPStorage.set("live-view", true);
      navigate("/app-selection");
    }
  }, [loginSuccess, queryParams]);

  // Set the login error message from BE if login fails due to invalid roles
  useEffect(() => {
    if (loginError) {
      if (
        loginError?.data?.message !== undefined &&
        loginError?.data?.message !== null &&
        loginError?.data?.message !== ""
      ) {
        setLoginErrorMessage(loginError?.data?.message);
      }
    }
  }, [loginError]);

  // When logged out from the calling appc, force logout the user from the current app
  useEffect(() => {
    if (data) {
      const ws = new FMDPWebSocket(data.id);

      ws.subscribe("ForceLogoutNotificationChannel", (response) => {
        if (response.message === "force_logout") {
          navigate("/logged_out", { replace: true });
        }
      });
    }
  }, [data]);

  return (
    <main className="login-layout authentication">
      <div className="login-form-container">
        {!loginSuccess && !loginError && (
          <div>
            <h1 className="page-title">Authenticating...</h1>

            <img className="happenings" src={loader} />
          </div>
        )}

        {loginError && (
          <p className="login-form-container_error text-red-500 text-sm mb-4">
            {loginErrorMessage}
            <QIButton onClick={() => login(queryParams)} className="qi-btn primary sm ">
              Try Again
            </QIButton>
          </p>
        )}
      </div>
    </main>
  );
};
